import { render, staticRenderFns } from "./toolbarAdminPage.vue?vue&type=template&id=4e4eb95c&scoped=true"
import script from "./toolbarAdminPage.vue?vue&type=script&lang=js"
export * from "./toolbarAdminPage.vue?vue&type=script&lang=js"
import style0 from "./toolbarAdminPage.vue?vue&type=style&index=0&id=4e4eb95c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4eb95c",
  null
  
)

export default component.exports